import type UserAgent from '@common/UserAgent/UserAgent'

import type { ISystemInfo } from '../definitions'

/**
 * Os és Browser infok elkérése.
 * @param ua - UserAgent.
 */
export default function getSystemInfo (ua: UserAgent): ISystemInfo {
  return {
    os: ua.osInfo,
    browser: ua.browserInfo
  }
}
